// extracted by mini-css-extract-plugin
module.exports = {"floatingWindowWp":"index_floatingWindowWp_3peiO","linear":"index_linear_23zQ4","dragBall":"index_dragBall_2Q8Fy"};